import React, {useState} from 'react';
import ModalLayout from "@layouts/modal";
import ButtonBase from "@atoms/button.base";
import ButtonTransparent from "@atoms/button.transparent";
import CircleLoading from "@molecules/lotties/circle_loading";
import {storeQuickSaleProperty} from "@models/property";
import {toast} from "react-toastify";

const PropertyQuickSaleModal = ({show, setShow, property_id}) => {
    const [loading, setLoading] = useState(false);

    const handleSubmit = (e) => {
        setLoading(true);

        storeQuickSaleProperty(property_id).then(result => {
            setShow(false);
            setLoading(false)

            toast.success("درخواست شما با موفقیت ثبت شد. کارشناس 2نبش تا 24 ساعت آینده با شما تماس خواهد گرفت.");
        })
    };

    return (
        <ModalLayout show={show} setShow={setShow} modalDialogClass="modal-sm report-modal" dialogBodyClassName="px-0">
            <div className="text-center mt-8 mt-lg-0">
                <h3 className="h2">درخواست فروش فوری ملک</h3>

                <div className="px-24 px-lg-32 pt-24 pb-40 pb-md-0">
                    <p>بعد از  ثبت درخواست، کارشناس متخصص ۲نبش؛ ملک شما را بررسی و با شما تماس خواهد گرفت و در صورت تایید کارشناس، ملک شما تا 10 روز آینده به صورت نقدی خریداری خواهد شد.</p>

                    <div className="mt-32 d-flex">
                        <ButtonTransparent onClick={() => setShow(false)} className="col-6">بی‌خیال</ButtonTransparent>
                        <ButtonBase disabled={loading} onClick={handleSubmit} color="danger-text col-6">
                            {
                                (loading) ?
                                    <CircleLoading width={24} height={24}/>
                                    :
                                    'ثبت درخواست'
                            }
                        </ButtonBase>
                    </div>
                </div>
            </div>
        </ModalLayout>
    );
};

export default React.memo(PropertyQuickSaleModal);
